module.exports = __webpack_public_path__ + "img/logo.edb5e47f.png";